/**
 * The Forecast grid: a horizontally scrolling table of part blocks (Open PO,
 * Forecast[, Total]) across the arrears / weekly / monthly / future buckets.
 */
import { RefObject, UIEvent } from 'react';
import { ForecastGridHeader, forecastColumnCount } from './ForecastGridHeader';
import { ForecastGridRow } from './ForecastGridRow';
import { ForecastGridLayout, ForecastTableRowWithStock } from './forecastGridTypes';

interface ForecastGridTableProps {
  rows: ForecastTableRowWithStock[];
  layout: ForecastGridLayout;
  tableRef: RefObject<HTMLDivElement | null>;
  onScroll: (e: UIEvent<HTMLDivElement>) => void;
  formatQty: (value: string | undefined) => string;
  onCellClick: (row: ForecastTableRowWithStock, bucketKey: string, bucketLabel: string) => void;
}

export function ForecastGridTable({
  rows, layout, tableRef, onScroll, formatQty, onCellClick,
}: ForecastGridTableProps) {
  return (
    <div
      ref={tableRef}
      onScroll={onScroll}
      className="overflow-x-auto border rounded-lg"
      style={{ maxHeight: 'calc(100vh - 400px)' }}
    >
      <table className="w-full text-sm">
        <ForecastGridHeader layout={layout} />
        <tbody className="divide-y divide-slate-200">
          {rows.length === 0 ? (
            <tr>
              {/* The cell spans a grid far wider than the viewport; pin the
                  message to the visible left edge so an empty result (e.g.
                  "Open PO only" for a forecast-only part) is actually seen. */}
              <td colSpan={forecastColumnCount(layout)} className="py-12 text-slate-500">
                <div className="sticky left-0 inline-block px-6">
                  No forecast data available. Import forecast data or check your filters.
                </div>
              </td>
            </tr>
          ) : (
            rows.map((row, idx) => (
              <ForecastGridRow
                key={`${row.part_number}-${row.record_type}-${idx}`}
                row={row}
                layout={layout}
                formatQty={formatQty}
                onCellClick={onCellClick}
              />
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
